import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import slideEarth from "../../../../images/slide-earth.jpg";
import CtaButton from '../../components/CtaButton/CtaButton';

const BULLETS = [
  "Sin doble contabilidad",
  "Certificados únicos y auditables",
  "Información validada por terceros",
];

function Hero() {
  return (
    <section
      className="bg-no-repeat bg-cover bg-[center_top] min-h-screen flex items-center pt-80 pb-80"
      style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)), url(${slideEarth})` }}
    >
      <div className="w-full max-w-[1100px] px-[6%] text-white">
        <img
          src="assets/images/logos/logo.png"
          alt="EcoRep logo"
          className="max-w-[320px] border-b-4 border-white mb-40 block"
        />
        <h1 className="text-48 font-extrabold leading-[1.2] mb-28 tracking-[-0.5px]">
          Cumple con la REP sin errores, con trazabilidad verificable y certificados seguros
        </h1>
        <p className="text-24 leading-[1.8] text-white/90 mb-36 max-w-[900px]">
          EcoRep es la plataforma que conecta a todos los actores de la cadena de aprovechamiento para registrar, validar y certificar materiales con respaldo técnico, reduciendo riesgos operativos y asegurando cumplimiento regulatorio.
        </p>
        <ul className="list-none p-0 m-0 mb-44">
          {BULLETS.map((text) => (
            <li key={text} className="flex items-center gap-12 text-20 font-medium py-10 text-white/[0.97]">
              <CheckCircleIcon className="!text-24 text-[#38BDF8] shrink-0" />
              {text}
            </li>
          ))}
        </ul>
        <div className="flex gap-16 flex-wrap">
          <CtaButton to="/contact" sx={{ fontSize: '1.8rem', padding: '16px 36px' }}>
            Solicitar demostración
          </CtaButton>
          <CtaButton to="/contact" variant="secondary-dark" sx={{ fontSize: '1.8rem', padding: '16px 36px' }}>
            Hablar con un experto
          </CtaButton>
        </div>
      </div>
    </section>
  );
}

export default Hero;
